module.exports = __webpack_public_path__ + "9cd9de53e26d23b6fcb7d4b972f95ef7.png";